import { useState, useEffect, useContext } from 'react'
import { CustomerContext } from '../../contexts/CustomerContext';
import reformatSchedules from './reformat-schedules';

// Groups the server's option-aware bookable start-times (schedule.bookableTimeslots)
// by day. All span/capacity logic now lives server-side (AppointmentAvailability),
// so this hook just waits until the bookable timeslots have loaded and groups them.
const useReformattedSchedules = (schedules, schoolId = undefined) => {
  const [reformatted, setReformatted] = useState({})
  const { customer } = useContext(CustomerContext)
  const currentSchoolId = (customer && customer.currentSchool.id) || schoolId;

  useEffect(() => {
    if (schedules.some((schedule) => !schedule.bookableTimeslots)) return

    setReformatted(reformatSchedules(schedules, currentSchoolId))
  }, [schedules])

  return reformatted
}

export default useReformattedSchedules
